import React from "react";
import { observable, computed, toJS } from 'mobx';
import { observer, inject } from "mobx-react";



@inject("store")
@observer
export default class PriceList extends React.Component {

	constructor(props) {
		super(props);
		this.state = { orderTemplates: [] }
		this.downloadPriceList = this.downloadPriceList.bind(this);
	}

	downloadPriceList(e, orderTemplate) {
		e.preventDefault()
		const reports = this.props.store.reports;
		const navigation = this.props.store.navigation;

		const res = reports.downloadFile(
			"/Umbraco/Api/MyPages/GetPriceList",
			{
				SiteId: navigation.SiteId,
				CustomerId: navigation.CustomerId,
				TemplateName: orderTemplate.Name
			}
		);
	}


	componentDidMount() {
		const navigation = this.props.store.navigation;
		console.debug("componentDidMount -> getOrderTEmplates");
		this.props.store.order.getOrderTemplates(navigation.SiteId).then(orderTemplates => {
			this.setState({
				orderTemplates: orderTemplates
			});
		});
	}

	render() {



        return (<div>
			<h6 className="text-muted text-normal text-uppercase">Download pricelist</h6>
            {!store.navigation.CustomerRoleIsReadOnly && 
            <div className="text-sm">
				<dl>
					{this.state.orderTemplates.map(orderTemplate => {
						return (<React.Fragment key={"orderTemplate_" + orderTemplate.Name}>
							<dt>{orderTemplate.Name} - {orderTemplate.OrderType} </dt>
							<dd>Warehouse date: {orderTemplate.StartDate}<br />
								{/*<a href="#" onClick={(e) => this.downloadPriceList(e, orderTemplate)}>Download</a>*/}
								<a href={"/Umbraco/Api/MyPages/GetPriceList?cid=" + this.props.store.navigation.CustomerId + "&sid=" + this.props.store.navigation.mainTree.Id + "&name=" + encodeURIComponent(orderTemplate.Name) + "&OrderType=" + encodeURIComponent(orderTemplate.OrderType)} target="_blank">Download</a>
							</dd>
						</React.Fragment>);
					})}
				</dl>
			</div>}
            {store.navigation.CustomerRoleIsReadOnly && 
            <div className="text-sm">
				No price lists to download
			</div>}
		</div>);

	}
}